module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/QuietZoneCalculator-de397abf84565e0a2b6b337029d77360.png";